import React from 'react';
import { Route, withRouter } from 'react-router';
import ItemmapList from "./components/itemmapList";
import ItemmapForm from "./components/itemmapForm";

const Itemmap = () => {
    return (
        <>
            <Route path="/itemmap/list" component={withRouter(ItemmapList)} />
            <Route path="/itemmap/edit/:id" component={ItemmapForm} />
            <Route path="/itemmap/clone/:id" component={ItemmapForm} />
            <Route path="/itemmap/create" component={ItemmapForm} />
        </>
    )
};

export default Itemmap;
